<template>
    <div class="radio-button-group radio-button-group-stars" :class="{'disabled':data.disabled}">
        <div class="btn-group btn-group-toggle" data-toggle="buttons" 
                   @mouseleave="revertStars()">
            <label v-for="(item, index) in data.list" :key="index" class="btn" :title="index == 0 ? $t('no_stars') : ''"
                   :class="[item.id ? 'rating-'+index : '', value >= item.id ? 'focus selected' : '']" @mouseover="changeStars(item.id)">
                <input type="radio"
                       :value="item.id"
                       :name="name"
                       :id="name+'-'+index"
                       :required="data.required"
                       @click.prevent="getValue(item.id)"
                       :disabled="item.disabled"
                       :checked="value == item.id">
                <span>★</span>
            </label>
        </div>
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';

export default {
    name: "Stars",

    mixins: [InputMixin],

    methods: {
        getValue(value) {
            this.fieldValue = value;
            this.changed();
        },
        changeStars(value) {
            this.fieldValue = value;
            $('.btn-group-toggle .btn').removeClass('hover');
            
            if(this.fieldValue == 1){
                $('.btn-group-toggle .btn.rating-1').addClass('hover');
            } else if(this.fieldValue == 2){
                $('.btn-group-toggle .btn.rating-1, .btn-group-toggle .btn.rating-2').addClass('hover');
            } else if(this.fieldValue == 3){
                $('.btn-group-toggle .btn.rating-1, .btn-group-toggle .btn.rating-2, .btn-group-toggle .btn.rating-3').addClass('hover');
            }
                
        },
        revertStars() {
            $('.btn-group-toggle .btn').removeClass('hover');
            
        },
        changed() {
            this.$emit('input', this.fieldValue);
        }
    }
}
</script>
